<script setup>
import { useCatalogState } from '../composables/CatalogState.js'

const {
  parameters,
  selectParameter,
} = useCatalogState();
</script>

<template>
  <!-- Parameters as buttons -->
  <template v-for="(parameter, pi) in parameters">
    <div v-if="parameter.options && parameter.options.length">
      <div class="mt-8"><span class="text-lg font-medium">{{ parameter.name }}</span></div>
      <div class="relative grid sm:grid-cols-4 lg:grid-cols-12 gap-2 w-full text-center mt-2 mb-2">
        <a href="#" v-for="(option, i) in parameter.options"
          class="parameter-option truncate"
          :class="{ 'option-selected': !!option.selected }"
          @click.prevent="() => selectParameter(option)">
          {{ option.name }}
        </a>
      </div>
    </div>
  </template>
</template>

<style scoped>
.parameter-option {
  @apply px-2 py-3 border border-gray-200 rounded-lg shadow bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-blue-900 outline-none; /* dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700 */
}

.parameter-option-compact {
  @apply px-3 py-2 border border-gray-200 text-sm rounded-lg shadow bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-blue-900 outline-none;
}

.parameter-option-compact-locked {
  @apply px-3 py-2 border border-gray-100 text-sm rounded-lg shadow bg-gray-50 dark:bg-gray-800 dark:border-gray-900 dark:text-gray-500 outline-none;
}

.parameter-option.option-selected,
.parameter-option-compact.option-selected {
  @apply border-blue-400 bg-blue-300 hover:bg-blue-200 dark:bg-blue-800 dark:border-blue-700 dark:hover:bg-blue-900;
}
</style>